import { prop } from "ramda";
import type { ActionsTemplatesApi, ActionTemplateCreate, ActionTemplateUpdate } from "../../api";
import type { UUID } from "../../utils/uuid";
import { Validation } from "../../utils/validation";

export class RepositoryActionsTemplates {
    constructor(private readonly actionsTemplatesApi: ActionsTemplatesApi) {}

    public validation = {
        create: new Validation((actionTemplateCreate: ActionTemplateCreate) =>
            this.actionsTemplatesApi.actionsTemplatesValidateCreateActionTemplate({
                actionTemplateCreate,
            }),
        ),
        update: new Validation(
            (actionTemplateUpdate: ActionTemplateUpdate, actionTemplateId: UUID) =>
                this.actionsTemplatesApi.actionsTemplatesValidateUpdateActionTemplate({
                    actionTemplateId,
                    actionTemplateUpdate,
                }),
        ),
    };

    protected extractId = prop("id");
}
